(function () {
  function findRealCta(container) {
    // The actual buy-button (add-to-cart or WhatsApp inquiry) always carries
    // this class — match on that first so we don't accidentally grab an
    // unrelated wa.me link elsewhere on the page (e.g. the trust row's
    // "Need help? Chat with us").
    var submitBtn = container.querySelector('.product-form__submit');
    if (submitBtn) return submitBtn;

    var cartBtn = container.querySelector(
      'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
    );
    if (cartBtn) return cartBtn;
    return container.querySelector('a[href*="wa.me"]');
  }

  function init(bar) {
    var sectionId = bar.dataset.sectionId;
    var infoContainer = document.getElementById('ProductInfo-' + sectionId);
    if (!infoContainer) return;

    // Move the bar to <body> so its `position: fixed` is relative to the
    // real viewport, not an ancestor with a `transform` (Dawn's own
    // scroll-reveal classes apply one, which creates a new containing block
    // even at the identity matrix — a well-known CSS gotcha).
    document.body.appendChild(bar);

    var ctaBtn = document.getElementById('FlorenceStickyBarCta-' + sectionId);
    var priceEl = bar.querySelector('.florence-sticky-bar__price');
    var sourcePrice = document.getElementById('price-' + sectionId);
    var realCta = findRealCta(infoContainer);

    if (!realCta) return;

    var realLabel = realCta.textContent.trim();
    if (realLabel) ctaBtn.textContent = realLabel;

    function syncPrice() {
      if (!sourcePrice || !priceEl) return;
      var candidates = sourcePrice.querySelectorAll('.price-item--sale, .price-item--regular');
      var visible = Array.prototype.filter.call(candidates, function (el) {
        return el.offsetParent !== null && el.tagName !== 'S';
      });
      if (!visible.length) return;
      // innerHTML (not textContent) so markup injected into the price by other
      // scripts, e.g. the Dirham symbol swap, is mirrored into the sticky bar too.
      var html = visible[0].innerHTML.trim();
      if (html) priceEl.innerHTML = html;
    }
    syncPrice();
    if (sourcePrice && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(sourcePrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    ctaBtn.addEventListener('click', function () {
      var current = findRealCta(infoContainer);
      if (current) current.click();
    });

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
      observer.observe(realCta);
    }
  }

  document.querySelectorAll('.florence-sticky-bar').forEach(init);
})();
